import { render, staticRenderFns } from "./ToolLoader.vue?vue&type=template&id=505aa865&scoped=true"
import script from "./ToolLoader.vue?vue&type=script&lang=js"
export * from "./ToolLoader.vue?vue&type=script&lang=js"
import style0 from "./ToolLoader.vue?vue&type=style&index=0&id=505aa865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505aa865",
  null
  
)

export default component.exports